<template>
  <BLayoutExpansion title="Профиль пользователя">
    <v-row dense>
      <v-col cols="12" lg="6">
        <BTextField
          v-model="form.email"
          validate="email"
          label="E-mail"
          :disabled="isView"
          :skeleton="skeleton"
          name="email"
        />
      </v-col>

      <v-col cols="12" lg="6">
        <BTextField
          v-model="form.phone"
          label="Телефон"
          :disabled="isView"
          :skeleton="skeleton"
          name="phone"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <BTextarea
          v-model="form.address"
          rows="3"
          label="Адрес"
          :disabled="isView"
          :skeleton="skeleton"
          name="address"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <BTextFieldAte
          :validate="{ required: !form.is_federal_level }"
          :region.sync="form.region"
          :municipality.sync="form.municipality"
          :school.sync="form.school"
          :skeleton="skeleton"
          :disabled="isView || isProfile"
          model="User"
          @change="[form.is_federal_level = false, $emit('change-ate')]"
          @click:clear="form.is_federal_level = true"
        />
      </v-col>

      <v-col cols="12" class="mt-1 mb-2">
        <v-checkbox
          v-model="form.is_federal_level"
          label="Федеральный уровень"
          :disabled="isView || isProfile"
          dense
          hide-details
          class="pa-0 ma-0"
          name="is_federal_level"
          @change="form.region = form.municipality = form.school = null"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col v-if="'timezone' in form" cols="12">
        <BAutocompleteCommon
          v-model="form.timezone"
          $type="timezone"
          :disabled="isView"
          :skeleton="skeleton"
          name="timezone_id"
        />
      </v-col>
    </v-row>

    <v-row v-if="'comment' in form" dense>
      <v-col cols="12">
        <BTextarea
          v-model="form.comment"
          rows="3"
          label="Комментарий"
          :disabled="isView"
          :skeleton="skeleton"
          name="comment"
        />
      </v-col>
    </v-row>

    <v-row v-if="!isCreate && ('last_login_at' in form)" dense>
      <v-col cols="12" :lg="!skeleton && 'auto'">
        <BTextField
          :value="form.last_login_at | dateFormatter"
          :skeleton="skeleton"
          label="Дата последней авторизации"
          disabled
        />
      </v-col>

      <v-col cols="12" :lg="!skeleton && 'auto'">
        <BTextField
          :value="form.last_login_ip"
          :skeleton="skeleton"
          label="IP последней авторизации"
          disabled
        />
      </v-col>

      <v-col cols="12" :lg="!skeleton && 'auto'">
        <BTextField
          :value="form.last_password_change_at | dateFormatter"
          :skeleton="skeleton"
          label="Последнее изменение пароля"
          disabled
        />
      </v-col>
    </v-row>
  </BLayoutExpansion>
</template>

<script>
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextFieldAte from '@/components/forms/BTextFieldAte.vue'
import BTextarea from '@/components/forms/BTextarea.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'

export default {
  name: 'UsersFormDetails',
  components: {
    BLayoutExpansion,
    BTextField,
    BTextFieldAte,
    BTextarea,
    BAutocompleteCommon,
  },
  props: {
    isCreate: Boolean,
    isEdit: Boolean,
    isView: Boolean,
    isProfile: Boolean,
    skeleton: Boolean,
    form: {
      type: Object,
      required: true,
    },
  },
}
</script>
